<div class="header-group" [attr.data-testid]="'header-group-' + title()">
  @if (title()) {
    <div class="header-group__title-wrapper" [matTooltip]="headerTooltip()">
      <mat-icon class="header-group__icon">
        {{ icon() }}
      </mat-icon>
      <div class="header-group__title">{{ title() }}</div>
    </div>
  }
  <div class="header-group__content">
    <ng-content></ng-content>
  </div>
</div>
